import { sendGTMEvent } from '@next/third-parties/google'
import { mapUrlToEventLocation } from '../../helpers/mapUrlToEventLocation'

export const gtmCreateAccountClicked = () => {
  const uuid = crypto.randomUUID()

  sendGTMEvent({
    event: 'sho_create_account_clicked',
    event_id: uuid,
    event_location: mapUrlToEventLocation(window.location.href),
  })
}
